import { HttpRequest, IHttpClient } from "@features/shared/request/model";
import { withLocale } from "@features/shared/locale";
import { IPrompt, IPromptsLibraryCategory, IPromptsLibrarySubcategory } from "../entities/prompts-library";

const SERVER_URL = `${process.env.NEXT_PUBLIC_API_URL}`;

export class TPromptsLibraryApi {
    constructor(private httpClient: IHttpClient) {}

    async getAllCategories() {
        return await this.httpClient.do<IPromptsLibraryCategory[]>(withLocale(`${SERVER_URL}/library/categories`));
    }

    async getSubcategoriesByCategoryId(categoryId: number) {
        return await this.httpClient.do<IPromptsLibrarySubcategory[]>(
            withLocale(`${SERVER_URL}/library/categories/${categoryId}/subcategories`)
        );
    }

    async getPromptsByCategoryId(categoryId: number) {
        return await this.httpClient.do<IPrompt[]>(
            withLocale(`${SERVER_URL}/library/categories/${categoryId}/prompts`)
        );
    }
}

export const PromptsLibraryApi = new TPromptsLibraryApi(HttpRequest);
